module.exports = __webpack_public_path__ + "mosha.f07e0fee.png";